(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-pincode-checker"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'fishinglure_delivery_pincode';

    const readSavedPincode = () => {
      try {
        return window.localStorage.getItem(storageKey) || '';
      } catch (error) {
        return '';
      }
    };

    const savePincode = (pincode) => {
      try {
        window.localStorage.setItem(storageKey, pincode);
      } catch (error) {
        return;
      }
    };

    document.querySelectorAll('[data-delivery-checker]').forEach((checker) => {
      if (checker.dataset.ready === 'true') return;
      checker.dataset.ready = 'true';

      const input = checker.querySelector('[data-delivery-pincode]');
      const button = checker.querySelector('[data-delivery-check]');
      const result = checker.querySelector('[data-delivery-result]');
      const resultText = checker.querySelector('[data-delivery-result-text]');
      const buyBox = checker.closest('.buy-box');
      if (!input || !button || !result || !resultText) return;

      input.value = readSavedPincode();
      input.addEventListener('input', () => {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
      });

      const showResult = (message, isError = false) => {
        resultText.textContent = message;
        result.hidden = false;
        result.classList.toggle('is-error', isError);
      };

      const selectedVariantId = () => buyBox?.querySelector('[data-main-variant]')?.value || '';

      const deliveryDate = (value) => {
        const date = new Date(`${value}T12:00:00+05:30`);
        return Number.isNaN(date.valueOf()) ? '' : new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short' }).format(date);
      };

      const checkPincode = async () => {
        const pincode = input.value.trim();
        if (!/^[1-9][0-9]{5}$/.test(pincode)) {
          showResult(checker.dataset.invalidMessage, true);
          input.focus();
          return;
        }

        savePincode(pincode);
        const endpoint = checker.dataset.endpoint.trim();
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        showResult(checker.dataset.checkingMessage);

        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 8000);
        try {
          const url = new URL(endpoint, window.location.origin);
          url.searchParams.set('pincode', pincode);
          url.searchParams.set('product_id', checker.dataset.productId);
          url.searchParams.set('variant_id', selectedVariantId());
          url.searchParams.set('weight_kg', checker.dataset.weightKg);
          url.searchParams.set('product_mrp', checker.dataset.productMrp);
          url.searchParams.set('length_cm', checker.dataset.lengthCm);
          url.searchParams.set('width_cm', checker.dataset.widthCm);
          url.searchParams.set('height_cm', checker.dataset.heightCm);
          const response = await fetch(url.toString(), {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            signal: controller.signal
          });
          if (!response.ok) throw new Error('serviceability-request-failed');
          const payload = await response.json();
          const data = payload.data && typeof payload.data === 'object' ? payload.data : payload;
          const serviceable = data.serviceable === true || data.delivery_available === true;
          const explicitlyUnavailable = data.serviceable === false || data.delivery_available === false;
          if (!serviceable && !explicitlyUnavailable) throw new Error('serviceability-response-invalid');

          if (!serviceable) {
            showResult(checker.dataset.unserviceableMessage, true);
            return;
          }

          const date = deliveryDate(data.estimatedDeliveryBy);
          if (!date) throw new Error('delivery-estimate-missing');
          const modes = [data.codAvailable ? checker.dataset.codAvailableMessage : checker.dataset.codUnavailableMessage];
          showResult(`${checker.dataset.serviceableMessage} ${checker.dataset.deliveryByMessage} ${date} • ${modes.join(' • ')}`);
        } catch (error) {
          showResult(checker.dataset.errorMessage, true);
        } finally {
          window.clearTimeout(timeout);
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      };

      button.addEventListener('click', checkPincode);
      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        checkPincode();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["help-center"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.querySelector('[data-help-dialog]');
  const launchers = [...document.querySelectorAll('[data-help-toggle]')];
  let launcher = launchers[0];
  if (!dialog?.showModal || !launcher) return;
  const open = () => {
    if (dialog.open) return;
    dialog.showModal();
    launchers.forEach(item => item.setAttribute('aria-expanded','true'));
    document.body.classList.add('fl-help-open');
  };
  launchers.forEach(item => item.addEventListener('click', event => {if(event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)return;event.preventDefault();launcher=item;open();}));
  dialog.querySelector('[data-help-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)dialog.close();
    }
    const ordersLink = event.target.closest('[data-help-orders]');
    if (ordersLink && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      const destination = new URL(ordersLink.href, location.origin);
      if (destination.pathname === location.pathname) {
        event.preventDefault();
        dialog.close();
        window.scrollTo({top:0, behavior:'instant'});
      }
    }
  });
  dialog.addEventListener('close', () => {document.body.classList.remove('fl-help-open');launchers.forEach(item => item.setAttribute('aria-expanded','false'));const target=launchers.find(item => item===launcher && item.getClientRects().length && getComputedStyle(item).visibility!=='hidden') || launchers.find(item => item.getClientRects().length && getComputedStyle(item).visibility!=='hidden');target?.focus({preventScroll:true});});
  try {
    sessionStorage.removeItem('fl-help-return');
  } catch(_) {}
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["help-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
  const form = document.querySelector('[data-track-form]');
  if (!form) return;
  const status = form.querySelector('[data-track-status]');
  const results = form.querySelector('[data-track-results]');
  const button = form.querySelector('button');
  const idleLabel = button.textContent;
  let controller;
  let generation = 0;
  const clear = () => {
    generation += 1;
    controller?.abort();
    results.replaceChildren();
    status.textContent = '';
    button.disabled = false;
    button.textContent = idleLabel;
  };
  form.addEventListener('input', clear);
  form.closest('dialog')?.addEventListener('close', () => {clear();form.reset();});
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!form.reportValidity() || button.disabled) return;
    clear();
    const current = generation;
    controller = new AbortController();
    const activeController = controller;
    const timer = setTimeout(() => activeController.abort(), 18000);
    button.disabled = true;
    button.textContent = form.dataset.loading;
    status.textContent = form.dataset.loading;
    try {
      const response = await fetch(form.action, {method:'POST',credentials:'omit',cache:'no-store',headers:{'Content-Type':'application/json'},signal:controller.signal,body:JSON.stringify({orderNumber:form.elements.orderNumber.value.trim(),phone:form.elements.phone.value.trim()})});
      const data = await response.json();
      if (generation !== current) return;
      status.textContent = typeof data.message === 'string' ? data.message : form.dataset.error;
      if (!response.ok) return;
      for (const shipment of Array.isArray(data.shipments) ? data.shipments.slice(0,20) : []) {
        let url;
        try {url = new URL(shipment.url);} catch {continue;}
        if (url.origin !== 'https://www.ithinklogistics.co.in' || !/^\/postship\/tracking\/[A-Za-z0-9-]{5,40}$/.test(url.pathname) || url.search || url.hash) continue;
        const link = document.createElement('a');
        link.className = 'fl-help__primary';
        link.href = url.href;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = form.dataset.open + ' · ' + String(shipment.number);
        results.append(link);
      }
    } catch {
      if (generation === current) status.textContent = form.dataset.error;
    } finally {
      clearTimeout(timer);
      if (generation === current) {button.disabled = false;button.textContent = idleLabel;}
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ithink-pincode-checker"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-ithink-pincode-checker]').forEach((component) => {
      const input = component.querySelector('[data-ithink-pincode-input]');
      const button = component.querySelector('[data-ithink-pincode-button]');
      const result = component.querySelector('[data-ithink-pincode-result]');
      const messages = component.querySelector('[data-ithink-pincode-messages]') || component.querySelector('.ithink-pincode-checker__messages');
      const show = (text, state) => { result.textContent = text; result.dataset.state = state; };
      const check = async () => {
        const pincode = input.value.replace(/\D/g, '').slice(0, 6);
        input.value = pincode;
        if (!/^[1-9]\d{5}$/.test(pincode)) { show(messages.dataset.invalid, 'error'); return; }
        button.disabled = true;
        show('', '');
        try {
          const params = new URLSearchParams({
            pincode,
            weight_kg: component.dataset.weightKg,
            product_mrp: component.dataset.productMrp,
            length_cm: component.dataset.lengthCm,
            width_cm: component.dataset.widthCm,
            height_cm: component.dataset.heightCm
          });
          const response = await fetch(`${component.dataset.endpoint}?${params.toString()}`);
          const data = await response.json();
          if (!response.ok) throw new Error(data.message);
          if (!data.serviceable) { show(messages.dataset.unavailable, 'error'); return; }
          const modes = [data.codAvailable ? messages.dataset.cod : '', data.prepaidAvailable ? messages.dataset.prepaid : ''].filter(Boolean).join(' ');
          const deliveryDate = new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short' }).format(new Date(`${data.estimatedDeliveryBy}T12:00:00+05:30`));
          show(`${messages.dataset.available} ${messages.dataset.deliveryBy.replace('DATE', deliveryDate)} ${modes}`, 'success');
        } catch (error) { show(messages.dataset.error, 'error'); }
        finally { button.disabled = false; }
      };
      button.addEventListener('click', check);
      input.addEventListener('keydown', (event) => { if (event.key === 'Enter') { event.preventDefault(); check(); } });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    const update = () => {
      const focused = document.activeElement;
      document.body.classList.toggle('fl-mobile-input', !!focused && focused.matches('input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]), textarea, select, [contenteditable="true"]'));
    };
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', () => setTimeout(update, 0));
    window.addEventListener('pageshow', update);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-share"] && !Shopify.designMode) return;
  try {
    (() => {
  function setup(root) {
    root.querySelectorAll('[data-product-share]').forEach(details => {
      if (details.dataset.shareReady) return;
      details.dataset.shareReady = 'true';
      const summary = details.querySelector('summary');
      const copy = details.querySelector('[data-share-copy]');
      const native = details.querySelector('[data-share-native]');
      const whatsapp = details.querySelector('[data-share-whatsapp]');
      const status = details.querySelector('[data-share-status]');
      const manual = details.querySelector('[data-share-manual-field]');
      const input = manual.querySelector('input');
      function getLink() {
        const url = new URL(details.dataset.shareUrl);
        url.search = '';
        url.hash = '';
        const variant = details.closest('.product-info')?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
        if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
        return url.href;
      }
      function updateLink() {
        const url = getLink();
        whatsapp.href = 'https://wa.me/?text=' + encodeURIComponent(details.dataset.shareTitle + ' ' + url);
        input.value = url;
        return url;
      }
      function placePanel() {
        const top = summary.getBoundingClientRect().top;
        const panelHeight = details.querySelector('.fl-product-share__panel').offsetHeight;
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const bottomSpace = viewportHeight - top - summary.offsetHeight;
        const bottomGuard = window.innerWidth <= 700 ? 170 : 24;
        details.classList.toggle('fl-product-share--above', bottomSpace < panelHeight + bottomGuard && top > panelHeight + 100);
      }
      native.hidden = typeof navigator.share !== 'function';
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) {updateLink(); status.textContent = ''; manual.hidden = true; placePanel();}
      });
      whatsapp.addEventListener('click', updateLink);
      copy.addEventListener('click', async () => {
        const url = updateLink();
        try {
          await navigator.clipboard.writeText(url);
          status.textContent = details.dataset.shareCopied;
          manual.hidden = true;
        } catch (_) {
          manual.hidden = false;
          input.focus(); input.select();
          status.textContent = details.dataset.shareManual;
        }
        placePanel();
      });
      native.addEventListener('click', async () => {
        try {await navigator.share({title: details.dataset.shareTitle, url: updateLink()});}
        catch (error) {
          if (error.name !== 'AbortError') {manual.hidden = false; updateLink(); input.focus(); input.select(); status.textContent = details.dataset.shareManual;}
        }
      });
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') {details.open = false; summary.focus(); event.stopPropagation();}
      });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('click', event => document.querySelectorAll('[data-product-share][open]').forEach(details => {if (!details.contains(event.target)) details.open = false;}));
})();
  } catch(e) { console.error(e); }
})();

})();
